__turbopack_context__.v({
  "hasIconLeading": "NavItem-module__uEQ5_G__hasIconLeading",
  "hasIconTrailing": "NavItem-module__uEQ5_G__hasIconTrailing",
  "iconLeading": "NavItem-module__uEQ5_G__iconLeading",
  "iconOnly": "NavItem-module__uEQ5_G__iconOnly",
  "iconOnlyMobile": "NavItem-module__uEQ5_G__iconOnlyMobile",
  "iconTrailing": "NavItem-module__uEQ5_G__iconTrailing",
  "isDesktop": "NavItem-module__uEQ5_G__isDesktop",
  "navItem": "NavItem-module__uEQ5_G__navItem",
  "text": "NavItem-module__uEQ5_G__text",
  "textOnlyDesktop": "NavItem-module__uEQ5_G__textOnlyDesktop",
});
